export default () => ({
  legend: {
    enabled: false,
  },
});
